import { render, staticRenderFns } from "./ListItemAuthor.vue?vue&type=template&id=2b2c1f1f&scoped=true&"
import script from "./ListItemAuthor.vue?vue&type=script&lang=js&"
export * from "./ListItemAuthor.vue?vue&type=script&lang=js&"
import style0 from "./ListItemAuthor.vue?vue&type=style&index=0&id=2b2c1f1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c1f1f",
  null
  
)

export default component.exports